export default "__VITE_ASSET__DkWN7Pzi__"